{
	"access_description": "Qui saranno disponibili la richiesta della chiave, l’accesso all’account e i piani.",
	"access_eyebrow": "Prossimamente",
	"access_link": "Richiedi accesso",
	"access_status": "Le fondamenta del portale sono pronte.",
	"access_title": "Il tuo account sviluppatore, in un unico posto.",
	"account": {
		"billing_access_until": "Accesso fino al {{date}}",
		"billing_period_unavailable": "Il periodo di fatturazione corrente non è disponibile.",
		"billing_portal_error": "Non è stato possibile aprire la gestione dell'abbonamento. Riprova.",
		"billing_renews": "Rinnovo il {{date}}",
		"billing_status_active": "Attivo",
		"billing_status_canceled": "Annullato",
		"billing_status_past_due": "Pagamento dovuto",
		"billing_status_synchronized": "Sincronizzato",
		"billing_status_trialing": "Periodo di prova",
		"danger_description": "L'eliminazione dell'account è permanente e interrompe l'accesso al portale sviluppatori.",
		"danger_irreversible": "L'eliminazione è irreversibile e l'account non può essere recuperato.",
		"danger_no_refund": "Il periodo già pagato non viene rimborsato automaticamente.",
		"danger_revoke_access": "Tutte le chiavi API e le sessioni verranno revocate.",
		"danger_stop_renewal": "Il rinnovo di ogni abbonamento attivo verrà interrotto prima dell'eliminazione.",
		"danger_title": "Zona pericolosa",
		"delete_account": "Elimina account",
		"delete_billing_error": "Non è stato possibile interrompere il rinnovo dell'abbonamento. Il tuo account è ancora attivo. Riprova quando vuoi.",
		"delete_code_description": "Inserisci il codice di sei cifre inviato al tuo indirizzo email verificato.",
		"delete_code_invalid": "Il codice non è valido o è scaduto. Riprova oppure richiedi un nuovo codice.",
		"delete_code_invalid_format": "Inserisci il codice di sei cifre.",
		"delete_code_label": "Codice di conferma",
		"delete_code_title": "Conferma eliminazione account",
		"delete_confirmation_phrase": "ELIMINA",
		"delete_cooldown_error": "Attendi {{seconds}} secondi prima di richiedere un altro codice.",
		"delete_deleting": "Eliminazione...",
		"delete_dialog_phrase_description": "Questo account non ha un'email verificata. Digita la frase di conferma esatta prima di eliminarlo immediatamente.",
		"delete_dialog_title": "Eliminare il tuo account?",
		"delete_dialog_verified_description": "Invieremo un codice di conferma solo dopo che avrai continuato. Nulla verrà eliminato finché non inserirai il codice.",
		"delete_generic_error": "Non è stato possibile eliminare l'account. Account e accesso sono rimasti invariati. Riprova.",
		"delete_phrase_exact": "Maiuscole e minuscole devono corrispondere esattamente.",
		"delete_phrase_instruction": "Digita la frase seguente per continuare:",
		"delete_phrase_invalid": "Digita la frase di conferma esattamente come mostrata.",
		"delete_phrase_label": "Frase di conferma",
		"delete_resend": "Invia un nuovo codice",
		"delete_resend_cooldown": "Nuovo invio tra {{seconds}}s",
		"delete_retry": "Riprova eliminazione",
		"delete_send_code": "Invia codice di conferma",
		"delete_token_stale": "Questa sessione di conferma è scaduta. Invia un nuovo codice per continuare.",
		"email_change_action": "Cambia email",
		"email_change_code_invalid": "Uno o entrambi i codici non sono validi o sono scaduti. Controllali e riprova, oppure richiedi nuovi codici.",
		"email_change_code_invalid_format": "Inserisci il codice di sei cifre.",
		"email_change_codes_description_single": "Inserisci il codice inviato a {{newEmail}}.",
		"email_change_codes_description_two": "Inserisci i codici inviati a {{newEmail}} e al tuo indirizzo email attuale.",
		"email_change_codes_expire": "I codici scadono a breve e possono essere usati una sola volta.",
		"email_change_codes_title": "Controlla la posta",
		"email_change_confirm": "Conferma cambio email",
		"email_change_confirming": "Conferma...",
		"email_change_cooldown_error": "Attendi {{seconds}} secondi prima di richiedere nuovi codici.",
		"email_change_current_code_label": "Codice inviato all'email attuale",
		"email_change_description": "Inserisci il nuovo indirizzo. Verificheremo la nuova casella e, quando richiesto, quella attuale prima di applicare modifiche.",
		"email_change_email_invalid": "Inserisci un indirizzo email valido.",
		"email_change_email_required": "Inserisci il nuovo indirizzo email.",
		"email_change_generic_error": "Non è stato possibile cambiare l'email. L'indirizzo attuale non è stato modificato. Riprova.",
		"email_change_new_code_label": "Codice inviato alla nuova email",
		"email_change_new_email_label": "Nuovo indirizzo email",
		"email_change_new_email_placeholder": "nuova@example.com",
		"email_change_ownership_error": "Questa email è già collegata a un altro account. Usa un indirizzo diverso.",
		"email_change_resend": "Invia nuovi codici",
		"email_change_resend_cooldown": "Nuovo invio tra {{seconds}}s",
		"email_change_retry_cooldown": "Riprova tra {{seconds}}s",
		"email_change_same_email": "Inserisci un'email diversa dall'indirizzo attuale.",
		"email_change_send_codes": "Invia codici di verifica",
		"email_change_title": "Cambia indirizzo email",
		"email_change_token_stale": "Questa sessione di verifica è scaduta. Invia nuovi codici per continuare.",
		"email_change_use_another": "Usa un'altra email",
		"email_label": "Email",
		"email_missing": "Nessuna email",
		"email_missing_value": "Nessun indirizzo email verificato",
		"email_unverified": "Non verificata",
		"email_unverified_value": "Verifica email in attesa",
		"email_verified": "Verificata",
		"free_plan": "Piano gratuito",
		"free_plan_description": "Non è attivo alcun abbonamento a pagamento sincronizzato.",
		"identity_description": "L'identità verificata associata a questo account sviluppatore.",
		"identity_title": "Identità account",
		"language_description": "Scegli la lingua usata nel portale.",
		"language_invalid": "Scegli una lingua supportata.",
		"language_label": "Lingua dell'interfaccia",
		"language_saved": "Lingua dell'interfaccia salvata.",
		"language_title": "Lingua",
		"manage_billing": "Gestisci abbonamento",
		"member_since": "Membro dal",
		"password_add_email_first": "Aggiungi e verifica un indirizzo email prima di impostare una password.",
		"password_change_action": "Cambia password",
		"password_change_description": "Tutte le altre sessioni attive verranno disconnesse dopo la modifica della password. La sessione corrente resterà attiva.",
		"password_change_title": "Cambia password",
		"password_configured": "Configurata",
		"password_confirm_label": "Conferma nuova password",
		"password_confirm_required": "Conferma la nuova password.",
		"password_current_invalid": "La password attuale non è corretta. Riprova.",
		"password_current_label": "Password attuale",
		"password_current_required": "Inserisci la password attuale.",
		"password_description": "Usa una password sicura e univoca per proteggere questo account sviluppatore.",
		"password_generic_error": "Non è stato possibile aggiornare la password. Riprova senza condividere codici di sicurezza.",
		"password_label": "Password",
		"password_mismatch": "Le password non corrispondono.",
		"password_new_description": "Usa almeno 8 caratteri.",
		"password_new_label": "Nuova password",
		"password_new_min": "Usa almeno 8 caratteri.",
		"password_not_configured": "Non configurata",
		"password_otp_code_label": "Codice email",
		"password_otp_description": "Invieremo un codice di verifica di otto caratteri alla tua email verificata prima di impostare una password.",
		"password_otp_invalid": "Il codice email non è valido o è scaduto. Controllalo e riprova.",
		"password_otp_invalid_format": "Inserisci il codice di otto caratteri ricevuto via email.",
		"password_otp_resend": "Invia un nuovo codice",
		"password_otp_send": "Invia codice di verifica",
		"password_otp_send_error": "Non è stato possibile inviare il codice di verifica. Riprova.",
		"password_otp_token_stale": "Questa sessione di verifica è scaduta. Invia un nuovo codice per continuare.",
		"password_save": "Aggiorna password",
		"password_saving": "Aggiornamento...",
		"password_set_action": "Imposta password",
		"password_set_title": "Imposta password",
		"password_success": "Password aggiornata.",
		"password_totp_invalid": "Il codice di autenticazione non è valido. Attendi un nuovo codice e riprova.",
		"password_verify_email_first": "Verifica il tuo indirizzo email prima di impostare una password.",
		"plan_current": "Attuale",
		"plan_description": "Consulta il piano sincronizzato con il tuo account di fatturazione.",
		"plan_error": "Non è stato possibile caricare i dettagli del piano.",
		"plan_loading": "Caricamento dettagli del piano",
		"plan_title": "Piano",
		"preferences_description": "Lingua e fuso orario delle analisi vengono salvati separatamente.",
		"preferences_error": "Non è stato possibile caricare le preferenze.",
		"preferences_loading": "Caricamento preferenze",
		"preferences_save_error": "Non è stato possibile salvare la preferenza. Riprova.",
		"preferences_title": "Preferenze",
		"retry": "Riprova",
		"retrying": "Nuovo tentativo...",
		"save_language": "Salva lingua",
		"save_time_zone": "Salva fuso orario",
		"security_description": "Un riepilogo dei metodi di autenticazione e delle sessioni che proteggono questo account.",
		"security_title": "Sicurezza",
		"session_cancel": "Annulla",
		"session_current": "Dispositivo corrente",
		"session_device_browser_os": "{{browser}} su {{os}}",
		"session_device_unknown": "Dispositivo sconosciuto",
		"session_last_active": "Attiva {{date}}",
		"session_location_unknown": "Posizione approssimativa non disponibile",
		"session_revoke": "Revoca",
		"session_revoke_description": "Questo dispositivo verrà disconnesso. La sessione corrente resterà attiva.",
		"session_revoke_error": "Non è stato possibile revocare la sessione. Riprova.",
		"session_revoke_label": "Revoca {{device}}",
		"session_revoke_title": "Revocare la sessione?",
		"session_revoking": "Revoca in corso...",
		"session_source_anonymous": "Sessione ospite",
		"session_source_email_otp": "Codice email",
		"session_source_impersonate": "Accesso assistenza",
		"session_source_magic_link": "Link magico",
		"session_source_oauth": "Accesso social",
		"session_source_passkey": "Passkey",
		"session_source_password": "Password",
		"session_source_password_reset": "Reimpostazione password",
		"sessions_description": "Controlla i dispositivi che hanno accesso a questo account sviluppatore.",
		"sessions_error": "Non è stato possibile caricare le sessioni.",
		"sessions_label": "Sessioni attive",
		"sessions_loading": "Caricamento sessioni attive",
		"sessions_one": "1 sessione attiva",
		"sessions_other": "{{count}} sessioni attive",
		"sessions_retry": "Riprova sessioni",
		"sessions_revoke_others": "Disconnetti tutte le altre sessioni",
		"sessions_revoke_others_confirm": "Disconnetti le altre",
		"sessions_revoke_others_description": "Tutti gli altri dispositivi verranno disconnessi. Il dispositivo corrente resterà connesso.",
		"sessions_revoke_others_title": "Disconnettere tutte le altre sessioni?",
		"subtitle": "Gestisci identità sviluppatore, sicurezza, preferenze e piano.",
		"time_zone_description": "Usa i confini del calendario locale per le analisi API.",
		"time_zone_hint": "Scegli un fuso orario IANA.",
		"time_zone_invalid": "Scegli un fuso orario IANA valido.",
		"time_zone_label": "Fuso orario delle analisi",
		"time_zone_required": "Scegli un fuso orario.",
		"time_zone_saved": "Fuso orario delle analisi salvato.",
		"time_zone_title": "Fuso orario",
		"title": "Account",
		"totp_code_invalid_format": "Inserisci il codice di sei cifre dell'app di autenticazione.",
		"totp_code_label": "Codice di autenticazione",
		"totp_continue": "Continua",
		"totp_description": "Usa un'app di autenticazione per proteggere l'accesso con un codice temporaneo.",
		"totp_device_label": "App di autenticazione",
		"totp_device_limit_error": "Hai raggiunto il limite di app di autenticazione. Rimuovine una prima di aggiungerne un'altra.",
		"totp_device_required": "Scegli un'app di autenticazione.",
		"totp_disable": "Disattiva autenticazione a due fattori",
		"totp_disable_description": "Gli accessi futuri non richiederanno più un codice. Le app di autenticazione collegate resteranno disponibili.",
		"totp_disable_generic_error": "Non è stato possibile disattivare l'autenticazione a due fattori. Riprova.",
		"totp_disable_invalid_code_error": "Il codice non è valido. Attendi un nuovo codice e riprova.",
		"totp_disable_method_error": "Questa app non può autorizzare la modifica. Aggiorna Account e riprova.",
		"totp_disable_title": "Disattivare l'autenticazione a due fattori?",
		"totp_disabling": "Disattivazione in corso...",
		"totp_empty": "Non è ancora collegata alcuna app di autenticazione.",
		"totp_expired_error": "Questa configurazione è scaduta. Ricomincia per generare un nuovo codice QR e una nuova chiave.",
		"totp_generic_error": "Non è stato possibile configurare l'app di autenticazione. Riprova.",
		"totp_identity_required_error": "Aggiungi un'email verificata o un metodo di accesso collegato prima di attivare l'autenticazione a due fattori.",
		"totp_invalid_code_error": "Il codice non è valido. Controlla l'app di autenticazione e riprova.",
		"totp_load_error": "Non è stato possibile caricare le app di autenticazione.",
		"totp_loading": "Caricamento app di autenticazione",
		"totp_manual_secret": "Chiave di configurazione manuale",
		"totp_name_description": "Facoltativo. Usa un nome che riconoscerai in seguito.",
		"totp_name_label": "Nome app di autenticazione",
		"totp_name_too_long": "Usa al massimo 100 caratteri.",
		"totp_qr_alt": "Scansiona questo codice QR con la tua app di autenticazione",
		"totp_qr_loading": "Generazione codice QR",
		"totp_scan_description": "Scansiona il codice QR, quindi inserisci il codice di sei cifre mostrato dall'app di autenticazione.",
		"totp_scan_title": "Collega la tua app di autenticazione",
		"totp_secret_once": "Questa chiave di configurazione viene mostrata solo durante questa procedura.",
		"totp_set_up": "Configura app di autenticazione",
		"totp_setup_description": "Assegna un nome facoltativo all'app prima di generare la chiave di configurazione monouso.",
		"totp_setup_title": "Configura un'app di autenticazione",
		"totp_title": "App di autenticazione",
		"totp_unnamed_device": "App di autenticazione",
		"totp_verified_on": "Verificata il {{date}}",
		"totp_verify": "Verifica e attiva",
		"totp_verifying": "Verifica in corso...",
		"two_factor_disabled": "Non attiva",
		"two_factor_enabled": "Attiva",
		"two_factor_label": "Autenticazione a due fattori"
	},
	"auth": {
		"back_to_login": "Torna al login",
		"back_to_signup": "Torna alla registrazione",
		"backup_code": "Codice di recupero",
		"confirm_password": "Conferma password",
		"confirm_password_placeholder": "Ripeti password",
		"confirm_password_required": "Conferma la password.",
		"continue_with": "Continua con {{provider}}",
		"email": "Email",
		"email_invalid": "Inserisci un indirizzo email valido.",
		"email_placeholder": "tu@email.it",
		"email_required": "Inserisci il tuo indirizzo email.",
		"forgot_code": "Codice",
		"forgot_code_required": "Inserisci il codice.",
		"forgot_description": "Riceverai un codice monouso se l'indirizzo appartiene a un account.",
		"forgot_new_password": "Nuova password",
		"forgot_password": "Password dimenticata?",
		"forgot_request_submit": "Invia il codice",
		"forgot_reset_description_link": "Scegli una nuova password per il tuo account.",
		"forgot_reset_description_otp": "Inserisci il codice ricevuto e scegli una nuova password.",
		"forgot_reset_submit": "Aggiorna password",
		"forgot_title": "Reimposta la password",
		"legal_and": "e la",
		"legal_prefix": "Registrandoti accetti i",
		"legal_privacy": "Privacy",
		"legal_terms": "Termini",
		"login": "Accedi",
		"login_failed": "Accesso con provider non completato. Riprova.",
		"login_submit": "Accedi alla dashboard",
		"mfa_authenticator": "Authenticator",
		"mfa_description": "Scegli uno dei metodi configurati sul tuo account.",
		"mfa_email": "Email",
		"mfa_passkey": "Passkey",
		"mfa_recovery": "Recupero",
		"mfa_title": "Verifica in due passaggi",
		"navigation": "Autenticazione",
		"or": "oppure",
		"password": "Password",
		"password_min": "Minimo 8 caratteri",
		"password_min_error": "Usa almeno 8 caratteri.",
		"password_mismatch": "Le password non coincidono.",
		"password_required": "Inserisci la password.",
		"register_with": "Registrati con {{provider}}",
		"send_email_code": "Invia codice via email",
		"sign_in_with": "Accedi con {{provider}}",
		"signup": "Registrati",
		"signup_submit": "Inizia gratis",
		"subtitle": "API per il TCG di One Piece",
		"use_passkey": "Usa la passkey",
		"verify": "Verifica",
		"verify_email_description": "Inserisci il codice a 6 cifre inviato al tuo indirizzo.",
		"verify_email_resend": "Invia un nuovo codice",
		"verify_email_resend_cooldown": "Nuovo invio tra {{seconds}}s",
		"verify_email_submit": "Verifica e continua",
		"verify_email_title": "Verifica la tua email"
	},
	"changelog": {
		"description": "Le modifiche più importanti per chi costruisce con l’API SeaLedger.",
		"entries": {
			"v1_2_0": {
				"item_1": "Preferenze e sicurezza dell’account.",
				"item_2": "Gestione centralizzata delle API key.",
				"item_3": "Miglioramenti alla documentazione OpenAPI.",
				"title": "Profilo sviluppatore"
			},
			"v1_3_0": {
				"item_1": "Endpoint di validazione per i deck.",
				"item_2": "Filtri per tipo, colore, costo e set.",
				"item_3": "Ricerche più veloci nel catalogo.",
				"title": "Deck validation e filtri estesi"
			},
			"v1_4_0": {
				"item_1": "Filtra le stampe per lingua e mercato.",
				"item_2": "Nuovi campi per stato di rilascio e edizioni in arrivo.",
				"item_3": "Riconoscimento automatico della lingua di stampa.",
				"title": "Supporto multilingua completo"
			}
		},
		"eyebrow": "Changelog",
		"title": "Novità e aggiornamenti"
	},
	"dashboard": {
		"active": "Attive",
		"analytics_error_description": "La gestione delle chiavi API e le altre sezioni della dashboard restano disponibili.",
		"analytics_error_title": "Le analisi non sono disponibili",
		"analytics_loading": "Caricamento riepilogo analitico",
		"api_key_page": "Pagina {{page}} di {{total}}",
		"api_key_views": "Viste delle chiavi API",
		"api_keys": "Chiavi API",
		"api_keys_description": "Usale nell'header X-API-Key. I segreti vengono mostrati una sola volta.",
		"api_keys_error_description": "Non è stato possibile caricare le credenziali. Riprova questa sezione.",
		"api_keys_error_title": "Le chiavi API non sono disponibili",
		"api_keys_loading": "Caricamento chiavi API",
		"average_latency": "Latenza media",
		"billing_error_description": "Non è stato possibile caricare i dettagli dell'abbonamento. L'utilizzo resta indipendente.",
		"billing_error_title": "L'abbonamento non è disponibile",
		"billing_loading": "Caricamento abbonamento",
		"billing_portal_failed": "Non è stato possibile aprire la gestione abbonamento.",
		"cancel": "Annulla",
		"copy_key": "Copia chiave",
		"create_key": "Crea chiave API",
		"create_key_description": "Aggiungi un nome che identifichi dove verrà usata questa credenziale.",
		"create_key_title": "Crea una chiave API",
		"creating_key": "Creazione in corso...",
		"dashboard_sections": "Sezioni della dashboard",
		"duration": "Durata",
		"endpoint": "Endpoint",
		"errors": "Errori 4xx/5xx",
		"expired": "Scadute",
		"free_plan": "Piano gratuito",
		"generate_key": "Genera nuova",
		"key_copied": "Copiata",
		"key_copy_failed": "Non è stato possibile copiare la chiave. Selezionala e copiala manualmente.",
		"key_create_failed": "Non è stato possibile creare la chiave API.",
		"key_create_failed_description": "Controlla il nome o il limite di chiavi attive, quindi riprova.",
		"key_created_description": "{{label}} è pronta. Copia il segreto prima di chiudere questa finestra.",
		"key_created_title": "Chiave API creata",
		"key_name_description": "Usa un nome riconoscibile di massimo 128 caratteri.",
		"key_name_label": "Nome chiave API",
		"key_name_placeholder": "Nome della chiave",
		"key_name_required": "Inserisci un nome per questa chiave API.",
		"key_name_too_long": "Usa al massimo 128 caratteri.",
		"key_revoke_failed": "Non è stato possibile revocare le chiavi API selezionate.",
		"key_revoked": "Chiave API revocata.",
		"key_saved": "Ho salvato la chiave",
		"key_status_active": "attiva",
		"key_status_expired": "scaduta",
		"key_status_revoked": "revocata",
		"keys_revoked": "Chiavi API revocate.",
		"latency_unavailable_description": "Non ci sono ancora richieste riuscite da misurare.",
		"latency_value": "{{value}} ms",
		"logs_error_description": "Non è stato possibile caricare le richieste recenti. Le altre sezioni della dashboard restano disponibili.",
		"logs_error_title": "I log recenti non sono disponibili",
		"logs_loading": "Caricamento log recenti",
		"manage_subscription": "Gestisci abbonamento",
		"monthly_quota": "Quota mensile",
		"new_key_description": "Copiala ora: non potrà essere visualizzata di nuovo.",
		"next_page": "Successiva",
		"no_active_keys_description": "Assegna un nome alla credenziale per iniziare a collegare la tua integrazione.",
		"no_active_keys_title": "Crea la tua prima chiave API",
		"no_api_keys": "Non è stata creata alcuna chiave API.",
		"no_expired_keys_description": "Le credenziali scadute compariranno qui come storico in sola lettura.",
		"no_expired_keys_title": "Nessuna chiave API scaduta",
		"no_logs_description": "Le chiamate API più recenti compariranno qui al loro arrivo.",
		"no_logs_title": "Nessuna richiesta recente",
		"no_revoked_keys_description": "Le chiavi revocate compariranno qui come storico in sola lettura.",
		"no_revoked_keys_title": "Nessuna chiave API revocata",
		"no_timeseries_description": "Le richieste compariranno qui dopo che la tua API avrà ricevuto traffico.",
		"no_timeseries_title": "Nessun dato sulle richieste",
		"not_available": "n/d",
		"overview": "Panoramica",
		"p95_latency": "p95 {{value}} ms",
		"p95_unavailable": "p95 non disponibile",
		"plan": "Piano",
		"previous_page": "Precedente",
		"quota_value": "{{used}} / {{limit}}",
		"rate_limited": "{{value}} con rate limit",
		"recent_logs": "Log recenti",
		"remaining": "{{value}} rimanenti",
		"renewal": "Rinnovo {{date}}",
		"requests_in_period": "{{value}} richieste nel periodo",
		"requests_today": "Richieste oggi",
		"retry": "Riprova",
		"retrying": "Nuovo tentativo...",
		"revoke": "Revoca",
		"revoke_all": "Revoca tutte",
		"revoke_all_description": "Tutte le chiavi attive verranno revocate in modo permanente.",
		"revoke_description": "La chiave verrà revocata in modo permanente.",
		"revoke_key_label": "Revoca {{label}}",
		"revoke_title": "Conferma revoca",
		"revoked": "Revocate",
		"revoking": "Revoca in corso...",
		"route_error_description": "Non è stato possibile mostrare la dashboard. Riprova senza perdere la sessione corrente.",
		"route_error_title": "Dashboard non disponibile",
		"seven_day_requests": "Richieste negli ultimi 7 giorni",
		"since": "dalle {{date}}",
		"status": "Stato",
		"store_key_title": "Salva subito questo segreto",
		"subscription": "Abbonamento",
		"subtitle": "Monitora attività API, quota e stato dell'integrazione.",
		"timeseries_error_description": "Non è stato possibile caricare lo storico delle richieste degli ultimi sette giorni.",
		"timeseries_error_title": "Lo storico richieste non è disponibile",
		"timeseries_label": "Grafico richieste degli ultimi sette giorni",
		"timeseries_loading": "Caricamento storico richieste",
		"title": "Dashboard",
		"total_requests": "{{value}} totali",
		"unavailable": "Non disponibile",
		"usage": "Utilizzo",
		"usage_error_description": "Non è stato possibile caricare quota e utilizzo.",
		"usage_error_title": "L'utilizzo non è disponibile",
		"usage_loading": "Caricamento utilizzo",
		"view_all": "Vedi tutti",
		"view_logs": "Vedi i log"
	},
	"description": "Uno spazio semplice per gli sviluppatori che vogliono credenziali, visibilità e, in seguito, un piano adatto al proprio utilizzo.",
	"eyebrow": "Portale sviluppatori",
	"feature_billing_description": "Scegli e gestisci un piano quando introdurremo i pagamenti.",
	"feature_billing_title": "Piani e pagamenti",
	"feature_key_description": "Richiedi e gestisci le credenziali per la tua integrazione.",
	"feature_key_title": "Chiavi API",
	"feature_usage_description": "Consulta le informazioni che contano per la tua integrazione.",
	"feature_usage_title": "Panoramica utilizzo",
	"footer": {
		"changelog": "Novità",
		"copyright": "© 2026 SeaLedger. Tutti i diritti riservati.",
		"description": "L'API REST per il One Piece Card Game. Costruita da collezionisti, per collezionisti.",
		"legal": "Legale",
		"made_for": "Fatto per i collezionisti di carte.",
		"openapi": "Specifica OpenAPI",
		"privacy": "Privacy",
		"product": "Prodotto",
		"resources": "Risorse",
		"status": "Pagina di stato",
		"terms": "Termini"
	},
	"header": {
		"account": "Account",
		"dashboard": "Dashboard",
		"documentation": "Documentazione",
		"language": "Lingua",
		"open_account_menu": "Apri menu account",
		"open_navigation": "Apri navigazione",
		"pricing": "Prezzi",
		"primary_navigation": "Navigazione principale",
		"profile": "Profilo",
		"retry_sign_out": "Riprova a uscire",
		"settings": "Impostazioni",
		"sign_in": "Accedi",
		"sign_out": "Esci",
		"sign_out_failed": "Non è stato possibile chiudere la sessione.",
		"start_free": "Inizia gratis",
		"switch_language": "Passa all'inglese"
	},
	"landing": {
		"account_deleted": "Il tuo account è stato chiuso e la sessione è terminata.",
		"api_example": "Esempio di risposta API",
		"cta_description": "Genera una chiave API e inizia a lavorare sul TCG di One Piece.",
		"cta_title": "Pronto a costruire con SeaLedger?",
		"docs_code_comment": "// Elenca tutte le carte di un set",
		"docs_eyebrow": "Documentazione",
		"docs_title": "Un'API pulita, prevedibile, REST.",
		"endpoint_card": "Dettaglio completo di una singola carta e del suo effetto localizzato.",
		"endpoint_cards": "Elenca le carte con filtri per nome, set, tipo, colore e rarità.",
		"endpoint_sets": "Set rilasciati, date di uscita e numero di carte.",
		"endpoint_validate": "Verifica che un mazzo rispetti le regole del formato.",
		"faq_1_answer": "Sì. Il piano Starter offre 100 richieste al giorno, senza carta di credito.",
		"faq_1_question": "Posso usare l'API gratuitamente?",
		"faq_2_answer": "Le carte sono disponibili in inglese, giapponese e francese, con testi e immagini localizzati.",
		"faq_2_question": "Quali lingue sono supportate?",
		"faq_3_answer": "L'API restituisce 429 Too Many Requests e l'header Retry-After per indicare quando riprovare.",
		"faq_3_question": "Cosa succede se supero il rate limit?",
		"faq_eyebrow": "FAQ",
		"faq_title": "Domande frequenti",
		"feature_catalog_description": "Carte, set, espansioni, formati e stampe in una struttura coerente.",
		"feature_catalog_title": "Catalogo completo",
		"feature_rate_description": "Gli header indicano sempre quante richieste rimangono alla tua integrazione.",
		"feature_rate_title": "Rate limit trasparente",
		"feature_webhook_description": "Ricevi eventi quando arrivano nuove stampe, set ed errata corrige.",
		"feature_webhook_title": "Webhook real-time",
		"features_description": "Dati normalizzati e documentati per passare dall'idea al primo endpoint in pochi minuti.",
		"features_eyebrow": "Per sviluppatori",
		"features_title": "Meno infrastruttura, più prodotto.",
		"hero_dashboard": "Vai alla Dashboard",
		"hero_description": "Oltre 1.800 carte, set, leader e deck — tutti accessibili tramite endpoint JSON veloci e documentati. Prova subito con la chiave gratuita.",
		"hero_eyebrow": "API REST per il One Piece Card Game",
		"hero_title_accent": "una chiamata dopo l'altra.",
		"hero_title_main": "L'intero universo delle carte,",
		"hero_try_api": "Prova la API",
		"metrics_updated": "Dati aggiornati al {{date}}",
		"pricing_description_developer": "Per app in produzione e bot attivi.",
		"pricing_description_enterprise": "Per piattaforme e grossi volumi.",
		"pricing_description_starter": "Per app personali e prototipi.",
		"pricing_enterprise_price": "Su richiesta",
		"pricing_eyebrow": "Prezzi",
		"pricing_item_daily_requests": "100 richieste al giorno",
		"pricing_item_images_full": "Immagini full-resolution",
		"pricing_item_images_low": "Immagini a bassa risoluzione",
		"pricing_item_monthly_requests": "50.000 richieste al mese",
		"pricing_item_read": "Endpoint di lettura",
		"pricing_item_read_validate": "Lettura e deck validation",
		"pricing_item_sla": "SLA dedicato",
		"pricing_item_support": "Account manager",
		"pricing_item_unlimited": "Richieste illimitate",
		"pricing_item_webhooks": "Webhook real-time",
		"pricing_month": " / mese",
		"pricing_popular": "Più popolare",
		"pricing_select": "Scegli {{name}}",
		"pricing_title": "Un piano che cresce con te.",
		"stat_average_latency": "latenza media API (30 giorni)",
		"stat_catalog_printings": "stampe nel catalogo",
		"stat_requests_last_30_days": "richieste API (30 giorni)"
	},
	"legal": {
		"eyebrow": "Legale",
		"last_updated": "Ultimo aggiornamento: {{date}}.",
		"privacy": {
			"data": {
				"description": "Trattiamo i dati necessari per erogare il portale: identificativi dell’account, preferenze e metadati tecnici sulle richieste. Le API key non vengono mostrate nuovamente dopo la loro creazione.",
				"title": "Dati trattati"
			},
			"purposes": {
				"description": "Usiamo questi dati per autenticare l’account, proteggere il servizio, applicare i limiti di utilizzo e fornire assistenza. Non vendiamo dati personali o segreti API.",
				"title": "Finalità"
			},
			"retention_and_rights": {
				"description": "Conserviamo i dati per il tempo necessario alle finalità dichiarate e agli obblighi legali. Puoi richiedere accesso, rettifica o cancellazione tramite il supporto.",
				"title": "Conservazione e diritti"
			},
			"title": "Informativa sulla privacy"
		},
		"terms": {
			"acceptable_use": {
				"description": "Puoi usare l’API per prodotti e strumenti compatibili con le leggi applicabili e i diritti dei titolari dei contenuti. Non è consentito aggirare limiti, controlli di sicurezza o restrizioni di accesso.",
				"title": "Utilizzo accettabile"
			},
			"access": {
				"description": "L’accesso all’API richiede un account sviluppatore valido. Le API key sono credenziali riservate: custodiscile in un gestore di segreti e non includerle in repository, URL o applicazioni client.",
				"title": "Accesso al servizio"
			},
			"availability": {
				"description": "Il servizio viene offerto senza garanzia di disponibilità continua. Possiamo aggiornare endpoint, limiti e piani comunicando le modifiche rilevanti nel changelog.",
				"title": "Disponibilità"
			},
			"title": "Termini di servizio"
		}
	},
	"logs": {
		"all_api_key_statuses": "Tutti gli stati delle chiavi",
		"all_api_keys": "Tutte le chiavi API",
		"all_methods": "Tutti i metodi",
		"all_statuses": "Tutti gli stati",
		"api_key": "Chiave API",
		"api_key_label": "Chiave API",
		"api_key_status_active": "Attiva",
		"api_key_status_expired": "Scaduta",
		"api_key_status_label": "Stato della chiave API",
		"api_key_status_revoked": "Revocata",
		"duration": "Durata",
		"duration_value": "{{value}} ms",
		"empty": "Nessun log corrisponde ai filtri.",
		"endpoint": "Endpoint",
		"export_csv": "Esporta CSV",
		"export_filename": "sealedger-log-richieste.csv",
		"eyebrow": "Monitoraggio",
		"filters_description": "Restringi la cronologia con i segnali che contano.",
		"filters_eyebrow": "Affina l'attività",
		"filters_label": "Filtri del log delle richieste",
		"load_more": "Carica altri",
		"method": "Metodo",
		"method_label": "Metodo",
		"not_available": "n/d",
		"requests_one": "{{formattedCount}} richiesta",
		"requests_other": "{{formattedCount}} richieste",
		"reset_filters": "Azzera",
		"route_label": "Route API",
		"status": "Stato",
		"status_label": "Stato",
		"subtitle": "Richieste recenti della tua integrazione.",
		"time": "Orario",
		"title": "Log delle richieste"
	},
	"primary_action": "Richiedi accesso",
	"private_area": {
		"error_description": "Non è stato possibile verificare la sessione o i dati dell'account. Riprova per continuare in sicurezza.",
		"error_title": "Area account non disponibile"
	},
	"secondary_action": "Come funziona",
	"status": {
		"availability_check": "Controllo della disponibilità globale.",
		"description": "Stato globale dell'infrastruttura pubblica di SeaLedger.",
		"eyebrow": "Stato del sistema",
		"healthy_title": "Tutti i sistemi sono operativi.",
		"infrastructure": "Infrastruttura SeaLedger",
		"operational": "Operativo",
		"unavailable": "Non disponibile",
		"unavailable_title": "Stato non disponibile."
	},
	"title": "Una casa più chiara per l’accesso alle tue API."
}
